import { refElements } from './elementUtils'

const layoutTap = { tabLabel: 'Layout', tabValue: 'layout' }
const borderTap = { tabLabel: 'Border', tabValue: 'border' }
const typoTap = { tabLabel: 'Typography', tabValue: 'typography' }
const ThemeTap = { tabLabel: 'Theme', tabValue: 'theme' }
const layoutTypoFill = [layoutTap, typoTap]
const layoutBorderTypoFillTheme = [layoutTap, borderTap, typoTap, ThemeTap]
const layoutBorderFill = [layoutTap, borderTap]
const layoutFill = [layoutTap]
const layoutTypo = [layoutTap, typoTap]
const layoutOnly = [layoutTap]

export const elementTabsStyle = {
  [refElements.COLUMNS]: layoutOnly,
  [refElements.SECTION]: layoutFill,
  [refElements.DIV]: layoutBorderFill,
  [refElements.CONTAINER]: layoutFill,
  [refElements.TEXT]: layoutTypoFill,
  [refElements.CARD]: layoutOnly,
  [refElements.IMAGE]: layoutOnly,
  [refElements.BUTTON]: layoutBorderTypoFillTheme,
  [refElements.DIVIDER]: layoutTypo,
  [refElements.CATEGORY_MENUS]: layoutOnly,
  [refElements.IMAGE_CAROUSEL]: layoutOnly,
  [refElements.CARD_GROUP]: layoutOnly,
  [refElements.COUNT_DOWN]: layoutTypo,
  [refElements.YOUTUBE]: [],
  [refElements.TEXT_EDITOR]: layoutBorderFill,
}



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/utils/styleTabUtils.js